import React, { Component } from 'react'
import FullCalendar from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!
import interactionPlugin from "@fullcalendar/interaction" // needed for dayClick


class FullCalendarCmp extends Component {



  render() {
    const { calendarFunctions, initEvents } = this.props
    return (
      <>
        <FullCalendar
          plugins={[dayGridPlugin, interactionPlugin]}
          initialView="dayGridMonth"
          events={initEvents || []}
          selectable={true}
          select={calendarFunctions.handleDateSelect}
          eventClick={calendarFunctions.handleEventClick}
        />
      </>
    )
  }
}

export default FullCalendarCmp
